module.exports = __webpack_public_path__ + "img/www.gartner.com.baeff100.png";